export const initialState = {
    loading: false,
    error: null,
    data: []
};

const baseRouteUrl = '/s3config';

export const url = {
    escrowConfig: `${baseRouteUrl}/external/base/escrow/config.json`
};
export const TYPE = {
    escrowConfigType: 'ESCROW_CONFIG'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_${TYPE.escrowConfigType}`:
            return {
                ...state,
                loading: false,
                data: action.data.data
            };
        case `ERROR_${TYPE.escrowConfigType}`:
            return {
                ...state,
                loading: false,
                error: true
            };
        case `REQUEST_${TYPE.escrowConfigType}`:
            return {
                ...state,
                loading: true,
                error: false
            };
        default:
            return state;
    }
};
